import { createSlice } from '@reduxjs/toolkit';

const ProviderSearchDataSlice = createSlice({
    name: 'providersearchdata',
    initialState: {
        data: []
    },
    reducers: {
        psdata: (state, param) => {
            return {
                ...state,
                data: [...state.data, param.payload]
            };
        },
        resetBody: () => {
            return {
                data: []
            };
        }
    }
});
const { actions, reducer } = ProviderSearchDataSlice;
export const { psdata, resetBody } = actions;
export default reducer;
